/**
 * NOTE: PolicyDeniedPane.jsx (the reference frontend bundle) imports
 * getHubDashboardHref from this path, but utils/urlNormalize.js was not
 * included in the provided bundle — there was no source to port. This is a
 * minimal pass-through (trim trailing slash) standing in for it; the
 * original's intended transform (e.g. appending a specific Hub dashboard
 * route) is unknown and should be confirmed/replaced if it differs.
 */
export function getHubDashboardHref(hubUrl) {
  const trimmed = String(hubUrl || '').trim();
  if (!trimmed) return '';
  return trimmed.replace(/\/$/, '');
}

export default { getHubDashboardHref };
